import { getDownload } from '../utils/api';
class AffordableReportService {
  generateRDProjectWorksheet(
    organizationId: string,
    propertyId: string,
    date: string,
    fileName: string,
    options?: Object,
  ) {
    const params = `?date=${date}`;
    return getDownload(
      `/${organizationId}/${propertyId}/generate-rd-project-worksheet${params}`,
      fileName,
      options,
    );
  }
}

export default AffordableReportService;
